var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$store.state.token == '')?_c('SiteHeader'):_vm._e(),(_vm.$store.state.token != '')?_c('SiteNavigation'):_vm._e(),_c('b-container',{attrs:{"fluid":"","id":"container-main"}},[_c('router-view')],1),_c('SiteFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }